/**
 * Copyright © 2026 Adnuntius AS.
 * UI-Router state declarations.
 */
import {Ng2StateDeclaration} from '@uirouter/angular';
import {firstValueFrom, tap} from 'rxjs';
import {StateDeclarationBuilder, AdnRouterHelperApi} from '../routing/state-utils';
import {LineItemContextActionsComponent} from '../line-item/line-item-context-actions.component';
import {emptyRouteView} from '../common/directives/html/route-view-components';
import {LineItemApiService, LineItemModel} from '../line-item/line-item-api.service';
import {AxLineItemListPageComponent} from './ax-line-item-list-page.component';
import {LineItemEditPageComponent} from '../line-item/line-item-edit-page.component';
import {SignalAdminResourcePageState} from '../common/controller/signal-admin-resource-page-state';
import {SignalAdminResourceTitleComponent} from '../common/controller/signal-admin-resource-title.component';
import {PERMISSIONS} from '../../components/auth/auth-constants';
import {UserProfileSaverService} from '../../components/session/user-profile-saver.service';



export function axLineItemStates(adnRouterHelper: AdnRouterHelperApi): Ng2StateDeclaration[] {
  const states = new StateDeclarationBuilder();
const lineItemApi = adnRouterHelper.services.service(LineItemApiService);
const permissions = adnRouterHelper.services.localUserPermissions();
const userProfileSaver = adnRouterHelper.services.service(UserProfileSaverService);
const readOnly = () => !permissions.hasAny(PERMISSIONS.manageAdvertising.apiKey)
  && !permissions.hasAny(PERMISSIONS.axAdvertiser.apiKey);
let rh = adnRouterHelper.createRouterHelper('ax-line-items.ax-line-item', LineItemApiService, 'app.adv', 'app');
    
        states.add(rh.listPath(), rh.list({
          resolve: {
            readOnly
          },
          views: {
            'content@app': {component: AxLineItemListPageComponent, bindings: {readOnly: 'listReadOnly'}},
            'context@app': emptyRouteView()
          }
        }))
          .add(rh.newItemPath(), rh.newItem())
          .add(rh.itemPath(), rh.item({
            resolve: {
              advertiserFromParam: function() {},
              orderFromParam: function() {},
              lineItemView: function($stateParams) {
                const dataViewApi = adnRouterHelper.services.dataViewApi();

                if (!$stateParams.isNew) {
                  return firstValueFrom(dataViewApi.getView(
                    'LineItemView', {id: $stateParams.id || 'undefined-id'}, false
                  ));
                }
              },
              full: () => false,
              viewType: () => 1,
              lineItemPage: function($stateParams) {
                const createState = (model: LineItemModel, isNew: boolean) => new SignalAdminResourcePageState(
                  {...model, resourceName: 'lineItem'}, isNew, readOnly(), lineItemApi, 'Line Item', 'name',
                  undefined, undefined,
                  {objectTypeKey: 'LineItem', crumbParams: ['Advertiser', 'Order']},
                  {warningMessage: 'The {{action}} of the Line Item will also stop it from serving ads.', object: 'Line Item'}
                );
                if ($stateParams.isNew) {
                  return createState({
                    id: $stateParams.id, userState: 'RESERVED', objectState: 'ACTIVE', validationWarnings: []
                  }, true);
                }
                return firstValueFrom(lineItemApi.get($stateParams.id).pipe(
                  tap((model) => userProfileSaver.saveObj(model, 'adnLastViewed'))
                )).then((model) => createState(model, false));
              },
              model: (lineItemPage: SignalAdminResourcePageState<LineItemModel>) => lineItemPage.model()
            },
            views: {
              'content@app': {
                component: LineItemEditPageComponent,
                bindings: {
                  state: 'lineItemPage', full: 'full', viewType: 'viewType',
                  orderFromParam: 'orderFromParam', advertiserFromParam: 'advertiserFromParam', lineItemView: 'lineItemView'
                }
              },
              'context@app': {
                component: LineItemContextActionsComponent,
                bindings: {state: 'lineItemPage', viewType: 'viewType'}
              },
              'title@app': {component: SignalAdminResourceTitleComponent, bindings: {state: 'lineItemPage'}}
            }
          }, 'LineItem'));
  return states.build();
}
